<template>
  <div>
    <van-nav-bar
      class="topBar"
      :title="llzName"
      left-arrow
      @click-left="onClickLeft"
      left-text="返回"
      right-text="主页"
      @click-right="handleHome"
    />
    <div class="container">
      <!-- 地图 -->
      <div id="map"></div>
      <!-- 联络站二维码 -->
      <van-popup v-model="showCode">内容</van-popup>
    </div>
  </div>
</template>
<script>
import L from 'leaflet'
import CT from '@/lib/CoordinateTranslation.min.js'
import request from '@/api/getLLZ.js'
export default {
  data () {
    return {
      id: '',
      showCode: false,
      points: [],
      map: null,
      layers: null,
      mapUrl: 'https://ditu.zjzwfw.gov.cn:443/mapserver/vmap/WMTS/1.0/zjvmap/tdt_biaozhunyangshi_2017',
      labelUrl: 'https://ditu.zjzwfw.gov.cn:443/mapserver/label/WMTS/1.0/zjvmap/tdt_biaozhunyangshi_2017',
      options: {
        // 地图基本功能配置项
        minZoom: 0,
        maxZoom: 20,
        center: { lon: 120.6, lat: 29.073 },
        zoom: 11,
        crs: L.CRS.CustomEPSG4326, // 自定义坐标体系 浙江省天地图的坐标体系,否则会有偏差
        zoomControl: true, // 禁用 + - 按钮
        doubleClickZoom: true, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
        dragging: true, // 禁止鼠标拖动滚动
        boxZoom: true, // 决定地图是否可被缩放到鼠标拖拽出的矩形的视图，鼠标拖拽时需要同时按住shift键.
        scrollWheelZoom: true // 禁止鼠标滚动缩放
      },
      point: {}
    }
  },
  created () {
    // this.getLLZinfo();
  },
  mounted () {
    this.init()
    // this.initMap();
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    handleHome () {
      this.$router.push('/home')
    },
    //   获取数据
    getLLZinfo () {
      request
        .LLZinfo()
        .then((Response) => {
          //   console.log(Response)
          this.points = Response
          this.initPonits()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 加载地图
    // initMap() {
    //   this.map = this.$map.createMap("map", this.options); // 地图容器id与基本配置
    //   this.$map.createLayers(this.map, this.mapUrl); // 引入地图图层
    //   this.$map.createLabels(this.map, this.labelUrl); // 引入标注
    //   //   this.initPonits();
    // },
    initPonits () {
      const markers = this.$map.createPoints()
      this.points.forEach((val) => {
        if (val.location) {
          var lat = val.location.latnum
          var lon = val.location.lonnum
        }
        // var lon = val.location.lonnum; // 点的经度
        // var lat = val.location.latnum; // 点的纬度
        // const setLat = CT.gcj_decrypt_exact(lat, lon).lat; // 弹框的纬度
        // const setLon = CT.gcj_decrypt_exact(lat, lon).lon; // 弹框的经度
        if (lat && lon) {
          var myIcon = L.icon({
            iconUrl: require('@/assets/images/marker-icon.png'),
            iconSize: [25, 41],
            iconAnchor: [15, 40]
          })
          // var m = L.marker([CT.gcj_decrypt_exact(lat,lon).lat,CT.gcj_decrypt_exact(lat,lon).lon]);
          const marker = L.marker([lat, lon], {
            icon: myIcon
          })
          marker.on('click', () => {
            // this.showCode = true
            this.$router.push({
              path: '/LLZdetail',
              query: {
                point: val
              }
            })
            // this.showIntroduce = true;
            L.popup()
              .setLatLng([lat + 0.02, lon])
              .setContent(val.llzName)
              .openOn(this.map)
          })
          // markers.addLayer(marker)
          marker.addTo(markers)
        }
        // map.addLayer(markers)
        markers.addTo(this.map)
      })
    },

    init () {
      if (this.$route.query && this.$route.query.id) {
        // console.log(this.$route.query.id)
        this.id = this.$route.query.id
        this.getLlzDetail()
      }
    },
    // 获取联络站详情信息
    getLlzDetail () {
      request
        .getLlzDetail(this.id)
        .then(Response => {
          this.options.center.lon = parseFloat(Response.location.lon)
          this.options.center.lat = parseFloat(Response.location.lat)
          this.initMap()
        })
        .catch(() => {
          console.log('网络异常！')
        })
    },
    // 初始化地图
    // 地图初始化
    initMap () {
      this.map = this.$map.createMap('map', this.options) // 地图容器id与基本配置
      this.$map.createWmtsNew(this.map, this.mapUrl) // 引入地图图层
      this.$map.createWmtsNew(this.map, this.labelUrl) // 引入标注

      // 当前位置经纬度 [lon, lat]
      this.map.setView([CT.gcj_decrypt_exact(this.options.center.lat, this.options.center.lon).lat, CT.gcj_decrypt_exact(this.options.center.lat, this.options.center.lon).lon], this.options.level)
      var markers = L.markerClusterGroup({ animateAddingMarkers: true })
      var myIcon = L.icon({
        iconUrl: require('@/assets/images/marker-icon.png'),
        iconSize: [25, 41],
        iconAnchor: [15, 40]
      })
      this.icon = myIcon
      this.markers = markers
      this.myIcon = myIcon
      var m = L.marker([CT.gcj_decrypt_exact(this.options.center.lat, this.options.center.lon).lat, CT.gcj_decrypt_exact(this.options.center.lat, this.options.center.lon).lon], { draggable: true, icon: myIcon })
      markers.addLayer(m)
      this.m = m
      this.map.addLayer(markers)
      var _this = this
      m.on('dragend', function (event) {
        _this.llzEdit.location.lat = CT.gcj_encrypt(m.getLatLng().lat, m.getLatLng().lng).lat
        _this.llzEdit.location.lon = CT.gcj_encrypt(m.getLatLng().lat, m.getLatLng().lng).lon
      })
      this.map_show = true
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
}
#map {
  height: 100vh;
  width: 99%;
  //   background: red;
}
</style>
